
    import './styles.scoped.css';
    export default {
  "code-editor-refresh": "awsui_code-editor-refresh_1gl9c_1vq6m_158",
  "code-editor": "awsui_code-editor_1gl9c_1vq6m_158",
  "pane": "awsui_pane_1gl9c_1vq6m_700",
  "pane__close-container": "awsui_pane__close-container_1gl9c_1vq6m_711",
  "pane__list": "awsui_pane__list_1gl9c_1vq6m_716",
  "pane__table": "awsui_pane__table_1gl9c_1vq6m_723",
  "pane__item": "awsui_pane__item_1gl9c_1vq6m_729",
  "pane__cell": "awsui_pane__cell_1gl9c_1vq6m_729",
  "pane__item--highlighted": "awsui_pane__item--highlighted_1gl9c_1vq6m_743",
  "pane__location": "awsui_pane__location_1gl9c_1vq6m_764",
  "pane__description": "awsui_pane__description_1gl9c_1vq6m_764",
  "focus-lock": "awsui_focus-lock_1gl9c_1vq6m_779",
  "editor": "awsui_editor_1gl9c_1vq6m_823",
  "editor-refresh": "awsui_editor-refresh_1gl9c_1vq6m_853",
  "status-bar": "awsui_status-bar_1gl9c_1vq6m_858",
  "status-bar-with-hidden-pane": "awsui_status-bar-with-hidden-pane_1gl9c_1vq6m_867",
  "status-bar__left": "awsui_status-bar__left_1gl9c_1vq6m_871",
  "status-bar__right": "awsui_status-bar__right_1gl9c_1vq6m_878",
  "status-bar__language-mode": "awsui_status-bar__language-mode_1gl9c_1vq6m_882",
  "status-bar__cursor-position": "awsui_status-bar__cursor-position_1gl9c_1vq6m_882",
  "status-bar__cog-button": "awsui_status-bar__cog-button_1gl9c_1vq6m_888",
  "tab-list": "awsui_tab-list_1gl9c_1vq6m_893",
  "tab-button": "awsui_tab-button_1gl9c_1vq6m_898",
  "tab-button--refresh": "awsui_tab-button--refresh_1gl9c_1vq6m_931",
  "tab-button--warnings": "awsui_tab-button--warnings_1gl9c_1vq6m_934",
  "tab-button--active": "awsui_tab-button--active_1gl9c_1vq6m_943",
  "tab-button--disabled": "awsui_tab-button--disabled_1gl9c_1vq6m_959",
  "tab-button--divider": "awsui_tab-button--divider_1gl9c_1vq6m_992",
  "tab-button--errors": "awsui_tab-button--errors_1gl9c_1vq6m_999",
  "count": "awsui_count_1gl9c_1vq6m_1008",
  "text": "awsui_text_1gl9c_1vq6m_1011",
  "loading-screen": "awsui_loading-screen_1gl9c_1vq6m_1033",
  "error-screen": "awsui_error-screen_1gl9c_1vq6m_1034"
};
  